<template>
  <div v-if="!canGetListOfUsers">
    Brak uprawnień
  </div>
  <div class="content" v-else>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>assignment</md-icon>
            </div>
            <div class="btn-container">
              <md-button class="md-info" @click="show = true"
                >Dodaj rolę</md-button
              >
            </div>
          </md-card-header>
          <md-card-content>
            <md-table v-model="rolesAll" table-header-color="green">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="ID">{{ item.id }}</md-table-cell>
                <md-table-cell md-label="Nazwa">{{
                  item.roleName
                }}</md-table-cell>

                <md-table-cell md-label="Zamówienia">
                  <md-switch
                    v-model="item.permlist.canGetListOfLeads"
                    @change="updateRole(item.roleName)"
                  />
                </md-table-cell>
                <md-table-cell md-label="Anonimizacja">
                  <md-switch
                    v-model="item.permlist.rodoPerm"
                    @change="updateRole(item.roleName)"
                  />
                </md-table-cell>
                <md-table-cell md-label="Użytkownicy">
                  <md-switch
                    v-model="item.permlist.usersPermission"
                    @change="updateRole(item.roleName)"
                  />
                </md-table-cell>
                <md-table-cell md-label="Statusy">
                  <md-switch
                    v-model="item.permlist.userStatus"
                    @change="updateRole(item.roleName)"
                  />
                </md-table-cell>
                <md-table-cell md-label="Role">
                  <md-switch
                    v-model="item.permlist.canCreateRole"
                    @change="updateRole(item.roleName)"
                  />
                </md-table-cell>
                <md-table-cell md-label="Szablon">
                  <md-switch
                    v-model="item.permlist.changeProject"
                    @change="updateRole(item.roleName)"
                  />
                </md-table-cell>
                <md-table-cell md-label="Admin">
                  <md-switch
                    v-model="item.permlist.changeRole"
                    @change="updateRole(item.roleName)"
                  />
                </md-table-cell>
                <md-table-cell md-label="">
                  <drop-down>
                    <a
                      slot="title"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                    >
                      <md-icon>more_horiz</md-icon>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li>
                        <a href.prevent="#" @click="deleteRole(item.roleName)"
                          >Usuń rolę</a
                        >
                      </li>
                    </ul>
                  </drop-down>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <Modal v-if="show">
      <template slot="header">
        <h4 class="modal-title">Dodaj rolę</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="show = false"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <form>
          <md-field>
            <label>Nazwa</label>
            <md-input type="text" v-model="roleName" />
          </md-field>
          <md-field>
            <label>Opis</label>
            <md-input type="text" v-model="description" />
          </md-field>
          <md-field>
            <label for="permissions">Uprawnienia</label>
            <md-select
              v-model="selectedPermissions"
              name="permissions"
              id="permissions"
              multiple
            >
              <md-option
                v-for="perm in perms"
                :key="perm.name"
                :value="perm.name"
                >{{ perm.description }}</md-option
              >
            </md-select>
          </md-field>
        </form>
      </template>
      <template slot="footer">
        <md-button :disabled="!validateForm" class="md-info" @click="addRole()">
          Dodaj
        </md-button>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '../../components/Modal'
import { mapGetters } from 'vuex'
export default {
  name: 'Roles',
  components: {
    Modal,
  },
  data() {
    return {
      show: false,
      perms: [
        {
          name: 'rodoPerm',
          description: 'Anonimizacja',
        },
        {
          name: 'usersPermission',
          description: 'Lista użytkowników',
        },
        {
          name: 'canCreateRole',
          description: 'Zarządzanie rolami',
        },
        {
          name: 'canGetListOfLeads',
          description: 'Lista zamówień',
        },
        {
          name: 'userStatus',
          description: 'Zarządzanie użytkownikamu',
        },
      ],
      roleName: '',
      description: '',
      selectedPermissions: [],
    }
  },
  methods: {
    updateRole(roleName) {
      this.$store
        .dispatch('updateRole', roleName)
        .then(() => this.$message('sukcess'))
        .catch(error => this.$error(error.response.statusText))
    },
    deleteRole(roleName) {
      this.$store
        .dispatch('deleteRole', roleName)
        .then(() => this.$message('sukcess'))
        .catch(error => this.$error(error.response.data))
    },
    async addRole() {
      await this.$store
        .dispatch('addRole', {
          roleName: this.roleName.trim(),
          roleDescription: this.description.trim(),
          permlist: this.selectedPermissions,
        })
        .then(() => this.$message('Rola została dodana'))
        .catch(error => this.$error(error.response.data))
      this.show = false
    },
  },
  computed: {
    ...mapGetters(['rolesAll', 'canGetListOfUsers']),
    validateForm() {
      return (
        !!this.roleName.trim() &&
        !!this.description.trim() &&
        !!Array.from(this.selectedPermissions).length
      )
    },
  },
}
</script>

<style scoped lang="scss">
.btn-container {
  text-align: right;
  & > * {
    margin-top: 25px;
  }
}
</style>
